module.exports = __webpack_public_path__ + "static/image10-3316bf85e9dc57a2f87a6d19a79a16c8.png";